document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    const price = form?.closest('.product-main')?.querySelector('[data-product-price]');
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });

  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('.qty');
      const input = wrapper?.querySelector('input[type="number"]');
      if (!input) return;
      const current = Number(input.value || 1);
      const min = Number(input.min || 1);
      input.value = Math.max(min, current + (button.hasAttribute('data-qty-plus') ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-earring-option]').forEach((select) => {
    const card = select.closest('.earring-product-card');
    const price = card?.querySelector('[data-earring-price]');
    const updatePrice = () => {
      const selected = select.options[select.selectedIndex];
      if (price && selected?.dataset.price) price.textContent = selected.dataset.price;
    };
    select.addEventListener('change', updatePrice);
    updatePrice();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ring-product-card').forEach((card) => {
    const carat = card.querySelector('[data-ring-carat]');
    const size = card.querySelector('[data-ring-size]');
    const price = card.querySelector('[data-ring-price]');
    const sizeDisplay = card.querySelector('[data-ring-size-display]');

    const updateRing = () => {
      const selectedCarat = carat?.options[carat.selectedIndex];
      const selectedSize = size?.options[size.selectedIndex];
      if (price && selectedCarat?.dataset.price) price.textContent = selectedCarat.dataset.price;
      if (sizeDisplay && selectedSize) sizeDisplay.textContent = `US Size ${selectedSize.value}`;
    };

    carat?.addEventListener('change', updateRing);
    size?.addEventListener('change', updateRing);
    updateRing();
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-loose-diamond-carat]').forEach((select) => {
    const card = select.closest('.loose-diamond-product-card');
    const price = card?.querySelector('[data-loose-diamond-price]');
    const updateLooseDiamondPrice = () => {
      const selected = select.options[select.selectedIndex];
      if (price && selected?.dataset.price) price.textContent = selected.dataset.price;
    };
    select.addEventListener('change', updateLooseDiamondPrice);
    updateLooseDiamondPrice();
  });
});

// ELARIS AJAX add-to-cart helpers for custom catalog cards and Shopify product cards.
(() => {
  const normalizeOption = (value = '') => String(value)
    .toLowerCase()
    .replace(/carats/g, 'carat')
    .replace(/\s+/g, ' ')
    .trim();

  const optionMatches = (actual, desired) => {
    const a = normalizeOption(actual);
    const d = normalizeOption(desired);
    if (!d) return true;
    if (a === d) return true;

    // Tolerate stores that name ring-size variants as "7", "Size 7", or "US 7".
    const dSize = d.replace(/^us\s+/, '').replace(/^size\s+/, '');
    const aSize = a.replace(/^us\s+/, '').replace(/^size\s+/, '');
    if (/^\d+(\.\d+)?$/.test(dSize) && aSize === dSize) return true;

    return a.includes(d) || d.includes(a);
  };

  const refreshCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.cart-count').forEach((el) => { el.textContent = cart.item_count; });
    } catch (_) {}
  };

  const setStatus = (container, message, type = '') => {
    if (!container) return;
    container.textContent = message;
    container.classList.remove('is-success', 'is-error');
    if (type) container.classList.add(`is-${type}`);
  };

  const addVariant = async (variantId, quantity = 1) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
    });
    if (!response.ok) {
      let detail = 'Unable to add this item to cart.';
      try { detail = (await response.json()).description || detail; } catch (_) {}
      throw new Error(detail);
    }
    return response.json();
  };

  const findVariantForCard = (product, card) => {
    const desired = Array.from(card.querySelectorAll('[data-cart-option]')).map((select) => {
      const option = select.options?.[select.selectedIndex];
      return option?.dataset.cartValue || option?.textContent?.split('—')[0]?.trim() || select.value;
    }).filter(Boolean);

    const available = (product.variants || []).filter((variant) => variant.available !== false);
    if (!available.length) return null;
    if (!desired.length) return available[0];

    return available.find((variant) => {
      const variantOptions = variant.options || [];
      return desired.every((wanted) => variantOptions.some((actual) => optionMatches(actual, wanted)));
    }) || null;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-elaris-add-to-cart]');
    if (!button) return;

    const card = button.closest('[data-elaris-catalog-card]');
    const status = card?.querySelector('[data-cart-status]');
    const handle = button.dataset.productHandle;
    const original = button.textContent;

    if (!handle) return;
    button.disabled = true;
    button.textContent = 'Adding…';
    setStatus(status, '');

    try {
      const productResponse = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
      if (!productResponse.ok) {
        throw new Error('Connect this catalog item to a Shopify product with the same title to enable checkout.');
      }
      const product = await productResponse.json();
      const variant = findVariantForCard(product, card);
      if (!variant) {
        throw new Error('The selected option is not yet available as a Shopify variant.');
      }

      await addVariant(variant.id, 1);
      await refreshCartCount();
      button.textContent = 'Added ✓';
      setStatus(status, 'Added to your cart.', 'success');
      window.setTimeout(() => { button.textContent = original; button.disabled = false; }, 1400);
    } catch (error) {
      button.textContent = original;
      button.disabled = false;
      setStatus(status, error.message || 'Unable to add this item to cart.', 'error');
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.quick-add-form');
    if (!form || form.tagName !== 'FORM') return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-quick-add-status]');
    const idField = form.querySelector('[name="id"]');
    if (!idField || !button) return;

    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    setStatus(status, '');

    try {
      await addVariant(idField.value, 1);
      await refreshCartCount();
      button.textContent = 'Added ✓';
      setStatus(status, 'Added to your cart.', 'success');
      window.setTimeout(() => { button.textContent = original; button.disabled = false; }, 1400);
    } catch (error) {
      button.textContent = original;
      button.disabled = false;
      setStatus(status, error.message || 'Unable to add this item to cart.', 'error');
    }
  });
})();
